module.exports = __webpack_public_path__ + "sourcesanspro-light.7951903bff82a82e7cde.woff";


//////////////////
// WEBPACK FOOTER
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/fonts/sourcesanspro/sourcesanspro-light.woff
// module id = ../../../../../src/fonts/sourcesanspro/sourcesanspro-light.woff
// module chunks = styles